import { stripUnit } from 'polished';
/**
 * font size mixin to set size and calculate line-height according to GEL
 *
 * hint: line-height is always 1 step up of font size. (1 step is 8px/0.5rem)
 *
 * @example
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${fontSize('16px')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'fontSize': '1rem',
 *   'lineHeight': '1.5rem'
 * }
 */

export function fontSize(sizeInRem) {
  var step = 0.5;
  var size = stripUnit(sizeInRem);
  var defaultLineHeight = 1.25; // compute the lineHeight

  var lineHeight = size >= 1 ? size + step - (size + step) % step : defaultLineHeight;
  return {
    fontSize: sizeInRem,
    lineHeight: "".concat(lineHeight, "rem")
  };
}